/*
 * Implements functionality which allows selection of multiple checkboxes at once
 * depending on a single checkbox called Master checkbox
 */
import { exists } from '@engine/lib/utility/exists';
export function handleSelectAll() {
  var $all_containers = $('.select-all-container');
  var $master_checkboxes = $all_containers.find('[id^="select_all"]');

  function containerFor(checkbox) {
    return $(checkbox).closest($all_containers);
  }

  function selectableCheckboxesFor($container) {
    return $container.find(':checkbox').not($master_checkboxes);
  }

  function toggleMasterCheckboxFor($container) {
    var isChecked = !exists(selectableCheckboxesFor($container).filter(':not(:checked)'));
    $container.find($master_checkboxes).prop('checked', isChecked);
  }

  function setInitialStateForMasterCheckboxes() {
    $all_containers.each(function (key, container) {
      toggleMasterCheckboxFor($(container));
    });
  }

  function listenForSelectAllChange() {
    $master_checkboxes.on('change', function () {
      selectableCheckboxesFor(containerFor(this)).prop('checked', this.checked);
    });
  }

  function listenForSubCheckboxesChange() {
    selectableCheckboxesFor($all_containers).on('change', function () {
      toggleMasterCheckboxFor(containerFor(this));
    });
  }

  if (exists($all_containers)) {
    setInitialStateForMasterCheckboxes();
    listenForSelectAllChange();
    listenForSubCheckboxesChange();
  }
}